export const GLOBAL_MEDIA_QUERIES = {
  sm: '(max-width: 599px)',
  md: '(max-width: 1365px)',
  lg: '(min-width: 1366px) and (max-width: 1440px)',
  xl: '(min-width: 1441px) and (max-width: 1900px)',
  xxl: '(min-width: 1920px)',
};
